import React from 'react'
import PropTypes from 'prop-types'

import { CLOUDFLARE_IMAGE_IDS } from '~/constants'
import { getCloudflareImageURL } from '~/utils'

const BillCreditPoster = props => {
  const { isMobile } = props

  return (
    <div className="relative flex flex-col items-center justify-center px-6 text-white md:text-center text-left  h-screen
    bg-sign-up-member bg-no-repeat bg-steel-550 bg-bottom bg-blend-soft-light bg-origin-content bg-auto"
    >
      {!isMobile ? (
        <img
          src={getCloudflareImageURL(CLOUDFLARE_IMAGE_IDS.STELLAR_LOGO_HORIZONTAL_WHITE)}
          alt="stellarfi logo"
          className="w-40 h-10 absolute top-20"
        />
      ) : null}
      <div className="flex flex-col my-40 px-4 md:px-20">
        <p className="md:font-bold font-extrabold text-5xl leading-14">
          Build credit with every bill you pay.
        </p>
        <p className="mt-10 text-xl leading-8">With StellarFi, your bills are paid on time and reported to the major credit bureaus.</p>
      </div>
    </div>
  )
}

BillCreditPoster.propTypes = {
  isMobile: PropTypes.bool.isRequired,
}

const Memoized = React.memo(BillCreditPoster)
export default Memoized
